<template>
  <div class="customer-edit" >
    <md-card>
      <md-card-header>
        <div class="md-title" v-if="customer._id">{{ customer.name }}</div>
        <translate tag="div" class="md-title" v-else>Add New Depot</translate>
        <translate tag="div" class="md-caption">Set basic information here</translate>
      </md-card-header>

      <md-card-content>
        <form novalidate @submit.stop.prevent="submit">

          <md-layout md-gutter="16">
            <md-layout>
              <md-input-container :class="{'md-input-invalid': !validName(customer.name) && nameDirty }">
                <md-icon>announcement</md-icon>
                <translate tag="label">Depot Name</translate>
                <md-input id="customer-name" @input.native="nameDirty = true" type="text" v-model="customer.name" :value="customer.name" required></md-input>
                <span class="md-error"><translate>Depot name must be filled</translate></span>
              </md-input-container>
            </md-layout>
            <md-layout>
              <md-input-container :class="{'md-input-invalid': !validCustomId(customer.customId) && customIdDirty }">
                <md-icon>label</md-icon>
                <translate tag="label">Depot Code</translate>
                <md-input id="customer-id" @input.native="customIdDirty = true" type="text" v-model="customer.customId" :value="customer.customId" required></md-input>
                <span class="md-error"><translate>Depot code must be filled</translate></span>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout class="heading-section">
            <translate class="md-subheading">Depot Address:</translate>
          </md-layout>

          <md-layout md-gutter="16">
            <md-layout>
              <md-input-container>
                <md-icon>home</md-icon>
                <md-input id="customer-address-street" type="text" v-model="customer.address.street" :value="customer.address.street" ></md-input>
                <translate tag="label">Street</translate>
              </md-input-container>
            </md-layout>
            <md-layout>
              <md-input-container>
                <md-icon>location_city</md-icon>
                <translate tag="label">City</translate>
                <md-input id="customer-address-city" type="text" v-model="customer.address.city" :value="customer.address.city" ></md-input>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout md-gutter="16">
            <md-layout>
              <md-input-container>
                <md-icon>markunread_mailbox</md-icon>
                <translate tag="label">Postal Code</translate>
                <md-input id="customer-address-postcode" type="text" v-model="customer.address.postcode" :value="customer.address.postcode" ></md-input>
              </md-input-container>
            </md-layout>
            <md-layout>
              <md-input-container>
                <md-icon>map</md-icon>
                <translate tag="label">Country</translate>
                <md-select v-model="customer.address.country">
                  <md-option value="LU">{{ trLuxembourg }}</md-option>
                  <md-option value="FR">{{ trFrance }}</md-option>
                  <md-option value="BE">{{ trBelgium }}</md-option>
                  <md-option value="DE">{{ trGermany }}</md-option>
                </md-select>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout class="heading-section">
            <translate class="md-subheading">Contact Person:</translate>
          </md-layout>

          <md-layout md-gutter="16">
            <md-layout>
              <md-input-container>
                <md-icon>perm_identity</md-icon>
                <translate tag="label">Name</translate>
                <md-input id="customer-contact-name" type="text" v-model="customer.contact.name" :value="customer.contact.name" ></md-input>
              </md-input-container>
            </md-layout>
            <md-layout>
              <md-input-container>
                <md-icon>contact_mail</md-icon>
                <translate tag="label">E-mail</translate>
                <md-input id="customer-contact-email" type="text" v-model="customer.contact.email" :value="customer.contact.email" ></md-input>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout md-gutter="16">
            <md-layout>
              <md-input-container>
                <md-icon>phone</md-icon>
                <translate tag="label">Phone</translate>
                <md-input id="customer-contact-phone" type="tel" v-model="customer.contact.phone" :value="customer.contact.phone"></md-input>
              </md-input-container>
            </md-layout>
            <md-layout>
              <md-input-container>
                <md-icon>print</md-icon>
                <translate tag="label">Fax</translate>
                <md-input id="customer-contact-fax" type="tel" v-model="customer.contact.fax" :value="customer.contact.fax" ></md-input>
              </md-input-container>
            </md-layout>
          </md-layout>

          <md-layout class="heading-section">
            <translate class="md-subheading">Products and Employees:</translate>
          </md-layout>

          <md-layout>
            <md-input-container>
              <md-icon>shop_two</md-icon>
              <translate tag="label">Product List</translate>
              <md-select v-model="customer.productList">
                <md-option :value="String('')" ><translate>No product list</translate></md-option>
                <md-option v-for="productList in allProductLists" :value="productList._id" :key="productList._id">{{productList.name}}</md-option>
              </md-select>
            </md-input-container>
          </md-layout>

          <md-layout>
            <md-input-container>
              <md-icon>people</md-icon>
              <translate tag="label">Employees</translate>
              <md-select name="employees" id="employees" multiple v-model="customer.users">
                <md-option v-for="user in availableUsers" :value="user._id" :key="user._id">{{ user.firstname + " " + user.lastname }} {{ (user.assigned) ? trAlreadyAssigned : '' }}</md-option>
              </md-select>
            </md-input-container>
          </md-layout>

          <md-layout>
            <md-layout>
              <md-input-container>
                <md-icon>speaker_notes</md-icon>
                <translate tag="label">Note</translate>
                <md-textarea id="customer-note" maxlength="500" v-model="customer.note" :value="customer.note"></md-textarea>
              </md-input-container>
            </md-layout>
          </md-layout>

        </form>
      </md-card-content>

      <md-card-actions>
        <md-button @click.native="cancelForm()"><translate>Cancel</translate></md-button>
        <md-button id="submit-customer" class="md-raised md-primary" @click.native="submitCustomer()"><translate>Save</translate></md-button>
      </md-card-actions>

      <md-snackbar md-position="bottom center" ref="snackbar" :md-duration="4000">
        <translate>The specified depot name already exists</translate>
        <md-button @click.native="$refs.snackbar.close()"><translate>Close</translate></md-button>
      </md-snackbar>
    </md-card>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapMutations, mapGetters, mapActions } from 'vuex'

export default {
  name: 'customer-form',
  data () {
    return {
      nameDirty: false,
      customIdDirty: false
    }
  },
  props: [ 'customer' ],
  async created () {
    // this function does not exist, it is replaced by fetchCustomersByUser
    /*
    if (this.customer._id !== undefined) {
      await this.$store.dispatch('fetchOneCustomer', this.customer._id)
    }
    */
  },
  watch: {
    language (lang) {
      this.onChangeLang(this.customer.address.country)
    }
  },
  computed: {
    availableUsers () { // get all available users: either 'Not assigned' or alredy assigned to this customer
      return this.allUsers.map((user) => {
        // find if a user is assigned to some customer
        let assignedTo = this.allCustomers.find((cust) => {
          return cust.users.includes(user._id)
        })
        return {
          '_id': user._id,
          'firstname': user.firstname,
          'lastname': user.lastname,
          'assigned': assignedTo !== undefined && assignedTo._id !== this.customer._id
        }
      })
    },
    trLuxembourg () {
      return this.$gettext('Luxembourg')
    },
    trFrance () {
      return this.$gettext('France')
    },
    trBelgium () {
      return this.$gettext('Belgium')
    },
    trGermany () {
      return this.$gettext('Germany')
    },
    trAlreadyAssigned () {
      return this.$gettext('(already assigned)')
    },
    language () {
      return this.$language.current
    },
    ...mapGetters([
      'allUsers',
      'allCustomers',
      'allProductLists'
    ])
  },
  methods: {
    onChangeLang (value) {
      // force fields to change ...
      this.customer.address.country = ''

      Vue.nextTick(() => {
        // ... and change them back to original values
        this.customer.address.country = value
      })
    },
    ...mapMutations([
      'customerCancelEdit'
    ]),
    ...mapActions([
      'saveCustomer'
    ]),
    nameExists (name) {
      if (name === 'Not assigned' || name === 'Non affecté' || name === 'Nicht zugeordnet') { // Depot can't be named 'Not assigned'
        return true
      }
      return this.allCustomers.some((cust) => {
        return cust.name === name && cust._id !== this.customer._id
      })
    },
    async submitCustomer () {
      this.nameDirty = true
      this.customIdDirty = true
      if (this.validName(this.customer.name) && this.validCustomId(this.customer.customId)) {
        if (this.nameExists(this.customer.name)) {
          this.$refs.snackbar.open()
        } else {
          await this.saveCustomer()
          this.$router.push({ name: 'tab-0' })
        }
      }
    },
    submit () {
      // just to prevent warning when opening expandable list of products
    },
    cancelForm () {
      this.$router.push({ name: 'tab-0' })
      this.customerCancelEdit()
    },
    validName (name) {
      return name !== ''
    },
    validCustomId (customId) { // TODO validate customId
      return customId !== ''
    }
  }
}
</script>

<style scoped>
.customer-edit {
  max-width: 1000px;
  margin: auto;
}
.heading-section {
  margin-top: 10px;
  margin-bottom: 10px;
}
.md-input-container label {
  color: rgba(0, 0, 0, .45);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/customers/Form.vue